<template>
  <div class="image-wall">
    <waterfall ref="wall"
      :watch="images"
      :line-gap="getSlotWidth">
      <waterfall-slot
        v-for="(image, index) in images"
        :width="image.width"
        :height="image.height"
        :order="index"
        :key="image.url"
        >
        <img v-if="image.category !== 'video'"
          class="image"
          v-lazy="image.url"
          :key="image.url"
          v-on:click="$store.state.isShowMergePicMode ? toggleSelect(image.url) : show(index)"
          :data-heat="image.heat"
          :alt="`photo by ${image.author.name}`">
        <i v-if="image.category !== 'video'" class="options" :data-status="checkStatus(image.url)"></i>

        <div class="video-imgbox" v-if="image.category === 'video'"> 
          <img
            class="video-image"
            v-lazy="image.url"
            :key="image.url"
            v-on:click="showVideo(image.vid)"
            :data-heat="image.heat"
            :alt="`photo by ${image.author.name}`">
          <div class="video-mask"></div>
        </div>
        <div class="video-info" v-if="image.category === 'video'">
          <div class="video-name line-limit-length" style="top:80%;">{{image.description !== "" ? image.description : image.name}}</div>
        </div>
      </waterfall-slot>
    </waterfall>
    <!-- 合成拼图模块 -->
    <merge-button :selected="this.selected" :title="this.title"/>
  </div>
</template>

<script>
import Waterfall from 'vue-waterfall/lib/waterfall'
import WaterfallSlot from 'vue-waterfall/lib/waterfall-slot'
import PhotoSwipe from 'photoswipe'
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default'
import 'photoswipe/dist/photoswipe.css'
import 'photoswipe/dist/default-skin/default-skin.css'
import isMobile from 'is-mobile'
import MergeButton from '@/components/merge-button.vue'

export default {
  data: () => ({
    showGalleryEvent: null,
    slotWidth: 300,
    selected: [],
    isMergeing: false,
    isShowingMergedPic: false,
    isShowingQrCodePic: false,
    mergedPicSrc: '',
    qrcodePicSrc: '',
    isMobile: isMobile()
  }),
  props: {
    title: String,
    images: Array,
    pswp: Object,
    showMergePicMode: Boolean,
    qrcodeDesc: String
  },
  components: {
    Waterfall,
    WaterfallSlot,
    MergeButton
  },
  computed:{
    getSlotWidth () {
      const count = parseInt(window.document.body.clientWidth / 300)
      let width = window.document.body.clientWidth / (count > 3 ? count : 3)
      if (this.$isMobile && this.$store.state.isShowVideoMode) {
        width = window.document.body.clientWidth
      }
      return width
    },
  },
  methods: {
    showGallery () {
      window.dispatchEvent(this.showGalleryEvent)
    },
    show (index) {
      const items = this.images.map((infos) => {
        const { url: src, width: w, height: h } = infos
        return { src, w, h, infos }
      })
      const options = {
        index,
        loop: false,
        tapToToggleControls: false,
        history: false
      }
      window.gallery = new PhotoSwipe(this.pswp.$el, PhotoSwipeUI_Default, items, options)
      window.gallery.init()
      this.showGallery()
    },
    showVideo (vid) {
      let url = 'http://' + window.location.host + '/video/' + vid
      window.open(url, '_blank')
    },
    toggleSelect (src) {
      let srcPosition = this.selected.indexOf(src)
      if (srcPosition !== -1) {
        this.selected.splice(srcPosition, 1)
      } else {
        this.selected.push(src)
      }
    },
    checkStatus (src) {
      if (!this.$store.state.isShowMergePicMode) return 'hide'
      return this.selected.indexOf(src) !== -1 ? 'selected' : 'noSelected'
    },
    checkVideoCoverStatus (image) {
      if (image.width < image.height) return 'vertical'
      else return 'horizontal'
    }
  },
  mounted () {
    this.showGalleryEvent = new Event('showGallery')
    // console.log('image-wall mounted', )
  },
  updated () {
    // console.log('image-wall updated')
    if (!this.$store.state.isShowMergePicMode && this.selected.length > 0) {
      this.selected = []
    }
  },
}
</script>
